import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import SuperAdminDashboard from '../components/dashboard/SuperAdminDashboard';
import AdminDashboard from '../components/dashboard/AdminDashboard';
import GarageOwnerDashboard from '../components/dashboard/GarageOwnerDashboard';
import EmployeeDashboard from '../components/dashboard/EmployeeDashboard';
import CustomerDashboard from '../components/dashboard/CustomerDashboard';
import AuthDebugInfo from '../components/AuthDebugInfo';

const Dashboard: React.FC = () => {
  const { user, isAuthenticated, isLoading } = useAuth();

  console.log('Dashboard component - user:', user?.name, 'role:', user?.role, 'isAuthenticated:', isAuthenticated, 'isLoading:', isLoading);
  console.log('Dashboard - localStorage check:', {
    hasToken: !!localStorage.getItem('access_token'),
    hasUser: !!localStorage.getItem('user'),
    hasRefresh: !!localStorage.getItem('refresh_token')
  });

  // Check if we have user data in localStorage but not in context yet
  const hasStoredUser = !!localStorage.getItem('user');
  const hasStoredToken = !!localStorage.getItem('access_token');
  const storedUser = hasStoredUser ? JSON.parse(localStorage.getItem('user')!) : null;

  // If loading or we have stored data but no context user yet, show loading
  if (isLoading || (hasStoredToken && hasStoredUser && !user)) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#008B8B]"></div>
        <p className="ml-4 text-gray-600">Loading dashboard...</p>
      </div>
    );
  }

  // Use context user or fallback to stored user
  const effectiveUser = user || storedUser;

  if (!effectiveUser) {
    console.log('Dashboard - no user found anywhere, showing debug info');
    return (
      <div className="min-h-screen bg-gray-50 p-8">
        <h1 className="text-2xl font-bold mb-4">Dashboard - No User Found</h1>
        <AuthDebugInfo />
      </div>
    );
  }

  // Render dashboard based on user role
  console.log('Dashboard - rendering for role:', effectiveUser.role);
  
  // Temporary debug info at the top
  const debugEnabled = new URLSearchParams(window.location.search).get('debug') === 'true';
  
  const renderDashboard = () => {
    switch (effectiveUser.role) {
      case 'super_admin':
        return <SuperAdminDashboard />;
      case 'admin':
        return <AdminDashboard />;
      case 'garage_owner':
        return <GarageOwnerDashboard />;
      case 'employee':
        return <EmployeeDashboard />;
      case 'customer':
        return <CustomerDashboard />;
      default:
        return (
          <div className="min-h-screen bg-gray-50 p-8">
            <h1 className="text-2xl font-bold mb-4">Unknown Role: {effectiveUser.role}</h1>
            <AuthDebugInfo />
          </div>
        );
    }
  };
  
  return (
    <div>
      {debugEnabled && (
        <div className="p-4 border-b bg-yellow-50">
          <AuthDebugInfo />
        </div>
      )}
      {renderDashboard()}
    </div>
  );
};

export default Dashboard;